<template>
  <div class="cta-box">
    <div class="avatar-box">
      <img class="support-avatar cover" src="https://onboarding.leaseback.de/img/FritzenReduced.jpg" />
    </div>
    <div class="details-box">
      <h1 class="cta-heading">Unsere Experten beraten Sie gern.</h1>
      <p class="cta-description">Herr Clemens Fritzen freut sich auf Ihren Anruf oder meldet sich zu einer gewünschten Zeit direkt bei Ihnen.</p>
      <div class="button-box">
        <a class="cta-button" href="mailto:info@leaseback.de">
          <svg xmlns="http://www.w3.org/2000/svg" class="cta-button-svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
            <path d="M12.854.146a.5.5 0 0 0-.707 0L10.5 1.793 14.207 5.5l1.647-1.646a.5.5 0 0 0 0-.708zm.646 6.061L9.793 2.5 3.293 9H3.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.207zm-7.468 7.468A.5.5 0 0 1 6 13.5V13h-.5a.5.5 0 0 1-.5-.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.5-.5V10h-.5a.5.5 0 0 1-.175-.032l-.179.178a.5.5 0 0 0-.11.168l-2 5a.5.5 0 0 0 .65.65l5-2a.5.5 0 0 0 .168-.11z" fill="#0176CD" />
          </svg>
          E-Mail</a
        >
        <a class="cta-button" href="tel:+4940609415150"
          ><svg class="cta-button-svg" width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M3.62 7.79C5.06 10.62 7.38 12.94 10.21 14.38L12.41 12.18C12.69 11.9 13.08 11.82 13.43 11.93C14.55 12.3 15.75 12.5 17 12.5C17.2652 12.5 17.5196 12.6054 17.7071 12.7929C17.8946 12.9804 18 13.2348 18 13.5V17C18 17.2652 17.8946 17.5196 17.7071 17.7071C17.5196 17.8946 17.2652 18 17 18C12.4913 18 8.1673 16.2089 4.97918 13.0208C1.79107 9.8327 0 5.50868 0 1C0 0.734784 0.105357 0.48043 0.292893 0.292893C0.48043 0.105357 0.734784 0 1 0H4.5C4.76522 0 5.01957 0.105357 5.20711 0.292893C5.39464 0.48043 5.5 0.734784 5.5 1C5.5 2.25 5.7 3.45 6.07 4.57C6.18 4.92 6.1 5.31 5.82 5.59L3.62 7.79Z" fill="#0176CD" />
          </svg>
          Anrufen</a
        >
        <a v-if="appointment == false" class="cta-button appointment" href="#" @click="makeAppointment()"
          ><svg class="cta-button-svg" width="18" height="20" viewBox="0 0 18 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M16 18H2V7H16V18ZM13 0V2H5V0H3V2H2C0.89 2 0 2.89 0 4V18C0 18.5304 0.210714 19.0391 0.585786 19.4142C0.960859 19.7893 1.46957 20 2 20H16C16.5304 20 17.0391 19.7893 17.4142 19.4142C17.7893 19.0391 18 18.5304 18 18V4C18 2.89 17.1 2 16 2H15V0H13ZM14 11H9V16H14V11Z" fill="#0176CD" />
          </svg>
          Termin vereinbaren</a
        >
      </div>
    </div>
  </div>
</template>

<script>
import { EventBus } from "@/event-bus.js";

export default {
  props: {
    appointment: Boolean,
  },
  methods: {
    makeAppointment() {
      EventBus.$emit("appointment_request");
    },
  },
};
</script>

<style scoped>
.cta-button-svg {
  margin-right: 10px;
  position: absolute;
  top: 15px;
  left: 30px;
}

.cta-box {
  background-color: #f3f3f3;
  padding: 48px 24px;
  border-radius: 15px;
  display: flex;
}

.avatar-box {
  display: flex;
  align-items: center;
  justify-content: center;
  margin: auto 2rem;
}

.support-avatar {
  width: 12rem;
  height: 12rem;
  margin-right: 1rem;
}

.cta-heading {
  font-size: 2em;
  width: 35ch;
  font-weight: 600;
  line-height: 48px;
  padding-bottom: 1.5rem;
}

.cta-description {
  font-size: 1em;
  color: #76798c;
  line-height: 27px;
  padding-bottom: 1.5rem;
}

.cta-button {
  background-color: #fff;
  border: 2px solid #0176cd;
  border-radius: 5px;
  padding: 1rem 2rem 1rem 4rem;
  color: #0176cd;
  font-weight: 700;
  margin-right: 1rem;
  text-align: center;
  line-height: normal;
  position: relative;
}

.button-box {
  display: flex;
}

@media (max-width: 1319px) {
  .cta-heading {
    font-size: 1.7rem;
    line-height: 2.5rem;
    width: 100%;
  }

  .cta-description {
    width: 100%;
  }
}

@media (max-width: 1060px) {
  .support-avatar {
    margin-right: auto;
  }

  .avatar-box {
    margin: auto auto 2.5rem auto;
  }

  .cta-box {
    width: 90%;
    flex-direction: column;
    margin: auto;
  }

  .cta-heading {
    font-size: 1.5rem;
    line-height: 2.5rem;
    width: 100%;
  }

  .cta-description {
    width: 100%;
  }

  .details-box {
    width: 90%;
    margin: auto;
  }

  .button-box {
    flex-direction: column;
    align-items: center;
  }

  .cta-button {
    margin-bottom: 2rem;
    width: 13rem;
  }

  .stage-container {
    overflow-x: hidden;
    width: 95%;
  }
}

@media (max-width: 880px) {
  .cta-heading {
    font-size: 1.15rem;
    line-height: 2rem;
  }

  .cta-box {
    width: 90%;
    margin: auto;
    padding: 48px 12px;
  }

  .cta-button {
    max-width: 11rem;
    margin: 0.5rem auto;
    font-size: 0.75em;
  }
}

@media (max-width: 880px) {
  .avatar-box,
  .appointment {
    display: none;
  }

  .button-box {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }

  .details-box {
    margin: 0;
  }

  .cta-box {
    width: 100%;
    border-radius: 0;
    position: fixed;
    bottom: 0;
    left: 0;
    margin: 0;
    padding: 1.5rem;
  }

  .cta-button {
    margin: 0;
    width: 20%;
  }

  .button-box a:nth-child(3) {
    display: none;
  }

  .cta-heading {
    padding-bottom: 0;
  }

  .cta-description {
    padding-bottom: 0.75rem;
    font-size: 0.85rem;
    line-height: 1.4;
  }
}

@media (max-width: 500px) {
  .cta-box {
    padding: 1rem;
  }
}

@media (max-width: 320px) {
  .cta-button {
    margin: 0.5rem auto;
    font-size: 0.55em;
  }
}

.details-box {
  width: 100%;
  box-sizing: border-box;
}

.button-box {
  display: flex;
  gap: 0.5rem;
  justify-content: flex-start;
}

.button-box a {
  padding: 0.75rem 1rem;
  border: none;
  width: 100%;
  box-sizing: border-box;
  align-items: center;
  justify-content: center;
  display: flex;
  max-width: none;
}

.button-box svg {
  position: static;
  height: 1rem;
}

.cta-box {
  box-sizing: border-box;
  z-index: 999;
}
</style>
